<template>
  <div class="wx_wrap-container">
    <div class="skeleton-center" v-loading="loading">
      <el-skeleton :rows="6" animated />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  beforeCreate() {},
  created() {
    this.toComplete();
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    toComplete() {
      let timer = setTimeout(() => {
        this.$router.push("/");
        clearTimeout(timer);
      }, 1500);
    },
  },
};
</script>

<style lang="scss" scoped>
.wx_wrap-container {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  .skeleton-center {
    margin: 0px auto;
    padding-top: 30px;
    width: 320px;
    height: 650px;
    background-color: #fff;
  }
}
</style>
